import { useTranslation } from 'react-i18next';
import { 
  Clock, Eye, CheckCircle2, XCircle, TrendingUp, 
  MessageSquare, Inbox, Reply 
} from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export const QuoteStats = ({ stats }) => {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
      <Card className="border-l-4 border-l-navy-600">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">{t('admin.totalQuotes')}</p>
              <p className="text-2xl font-bold text-navy-800">{stats.total}</p>
            </div>
            <TrendingUp className="w-8 h-8 text-navy-600 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-amber-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">{t('admin.pending')}</p>
              <p className="text-2xl font-bold text-amber-600">{stats.pending}</p>
            </div>
            <Clock className="w-8 h-8 text-amber-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-blue-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">{t('admin.reviewed')}</p>
              <p className="text-2xl font-bold text-blue-600">{stats.reviewed}</p>
            </div>
            <Eye className="w-8 h-8 text-blue-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-green-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">{t('admin.approved')}</p>
              <p className="text-2xl font-bold text-green-600">{stats.approved}</p>
            </div>
            <CheckCircle2 className="w-8 h-8 text-green-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-red-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">{t('admin.rejected')}</p>
              <p className="text-2xl font-bold text-red-600">{stats.rejected}</p>
            </div>
            <XCircle className="w-8 h-8 text-red-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const ContactStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <Card className="border-l-4 border-l-navy-600">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">Total Messages</p>
              <p className="text-2xl font-bold text-navy-800">{stats.total}</p>
            </div>
            <MessageSquare className="w-8 h-8 text-navy-600 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-amber-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">New</p>
              <p className="text-2xl font-bold text-amber-600">{stats.new}</p>
            </div>
            <Inbox className="w-8 h-8 text-amber-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-blue-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">Read</p>
              <p className="text-2xl font-bold text-blue-600">{stats.read}</p>
            </div>
            <Eye className="w-8 h-8 text-blue-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-l-4 border-l-green-500">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">Replied</p>
              <p className="text-2xl font-bold text-green-600">{stats.replied}</p>
            </div>
            <Reply className="w-8 h-8 text-green-500 opacity-50" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
